import { render } from "./payQp.vue?vue&type=template&id=6f08dd27&scoped=true"
import script from "./payQp.vue?vue&type=script&lang=js"
export * from "./payQp.vue?vue&type=script&lang=js"

import "./payQp.vue?vue&type=style&index=0&id=6f08dd27&scoped=true&lang=css"
import "./payQp.vue?vue&type=style&index=1&id=6f08dd27&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6f08dd27"

export default script